<div [class]="styleClass || class">
  <div
    class="w-full h-full flex items-center justify-center"
    [ngClass]="imageClass"
    [ngClass]="{ hidden: !imageLoader }"
  >
    <i class="pi pi-spin pi-spinner text-sm"></i>
  </div>
  <img
    [ngClass]="[imageLoader ? 'hidden' : '', imageClass]"
    [alt]="alt"
    class="w-full h-full object-cover object-center"
    (error)="onImageError()"
    [src]="src || imgId"
    (load)="onImageLoad()"
  />
</div>
